/** Fetch whether methodology analyse is enabled on the API. */

import axios from 'axios';
import { auth } from '@/lib/firebase';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

export type MethodologyGateStatus = {
  methodology_enabled: boolean;
  methodology_version?: string | null;
  message?: string | null;
  running_order?: string[];
};

export async function fetchMethodologyGateStatus(): Promise<MethodologyGateStatus> {
  let token: string | undefined;
  if (auth.currentUser) {
    try {
      token = await auth.currentUser.getIdToken();
    } catch {
      /* proceed without */
    }
  }
  const { data } = await axios.get(`${API_BASE_URL}/api/agents/placeholders`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    timeout: 15000,
  });
  return {
    methodology_enabled: Boolean(data?.methodology_enabled),
    methodology_version: data?.methodology_version ?? null,
    message: data?.message ?? null,
    running_order: data?.running_order ?? [],
  };
}
